export default {
      id: "eye_close-usage",
      viewBox: "0 0 21 13",
      url: __webpack_public_path__ + "sprite.svg#eye_close-usage",
      toString: function () {
        return this.url;
      }
    }